import { doc, getDoc, serverTimestamp, setDoc, updateDoc } from 'firebase/firestore';
import { updateProfile } from 'firebase/auth';
import { db } from '../firebase';

export async function ensureUserProfile(user, extras = {}) {
  if (!user?.uid) return null;
  const ref = doc(db, 'users', user.uid);
  const snap = await getDoc(ref);
  const displayName = (extras.displayName || user.displayName || '').trim();

  if (!snap.exists()) {
    await setDoc(ref, {
      displayName,
      email: user.email || '',
      photoUrl: user.photoURL || '',
      emailVerified: Boolean(user.emailVerified),
      onboardingComplete: false,
      role: 'user',
      accountStatus: 'active',
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    });
    return { displayName, onboardingComplete: false, accountStatus: 'active' };
  }

  const data = snap.data();
  const patch = {};
  if (displayName && !data.displayName) patch.displayName = displayName;
  if (user.email && data.email !== user.email) patch.email = user.email;
  if (user.photoURL && data.photoUrl !== user.photoURL) patch.photoUrl = user.photoURL;
  if (user.emailVerified !== data.emailVerified) patch.emailVerified = user.emailVerified;
  if (Object.keys(patch).length) {
    patch.updatedAt = serverTimestamp();
    await updateDoc(ref, patch);
  }
  return { ...data, ...patch };
}

export async function updateProfileBasics(user, { displayName }) {
  const name = (displayName || '').trim();
  if (name) await updateProfile(user, { displayName: name });
  await updateDoc(doc(db, 'users', user.uid), {
    displayName: name,
    emailVerified: Boolean(user.emailVerified),
    updatedAt: serverTimestamp(),
  });
}

export async function completeOnboarding(uid, extras = {}) {
  await updateDoc(doc(db, 'users', uid), {
    onboardingComplete: true,
    ...extras,
    updatedAt: serverTimestamp(),
  });
}
